import React, { useState, useEffect } from "react";
import PrimaryButton from "../../elements/primary-button";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import RangeOptionSelect from "../../elements/range-option-select";
import PropTypes from "prop-types";
import Slider from "./components/Slider";
import CashOptions from "./components/CashOptions";
import "./style.scss";
import InfoModal from "../../components/InfoModal";
import InfoIcon from "../../svg-icons/info";

/* Realized too late that 'Refine plan' and 'Choose financing' were supposed to be different pages, hence the somewhat messy code.
   This component is meant to be usable for both. */

const PdpRefinePlan = ({ heading, tabs, info, sliders, loanDisclaimer, cashOptions, checkoutButton, onCheckout, onOptionSelected, onTabSelected }) => {
  /* State is stored as an array of tabs with arrays of states. */
  const [plan, setPlan] = useState(null);
  // const [modalContent, setModalContent] = useState({});
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [currentTab, setCurrentTab] = useState(tabs ? tabs.defaultOption : null);
  const openInfoModal = content => {
    // setModalContent(content);
    setShowInfoModal(true);
  };
  const updatePlan = (tab, index, value, val) => {
    let newPlan = [...plan];
    if (val) {
      val.value = value === true || value === false ? val.value : value;
      val.price = value === true || value === false ? 0 : value;
      value = val;
    }

    newPlan[tab][index] = value;
    setPlan(newPlan);
    if (onOptionSelected) {
      onOptionSelected(newPlan, tab);
    }
    onCheckout(plan, tab, "");
  };
  let disclaimerText = loanDisclaimer;

  useEffect(() => {
    const tab1 = sliders.map(slider => {
      /* Slider can be either a toggle or a range slider */
      return slider.selected ? slider.selected : slider.value;
    });
    /* Maybe not super elegant to always have the cash options included even when not used, but it works */
    const tab2 =
      cashOptions && cashOptions.checkboxes
        ? cashOptions.checkboxes.map(box => {
          return box.selected;
        })
        : [];

    let disclaimerText = loanDisclaimer;
    if (tabs && currentTab && currentTab.value != tabs.defaultOption.value && cashOptions) {
      disclaimerText = cashOptions.disclaimer;
    }
    setPlan([tab1, tab2]);
  }, [sliders]);

  return (
    <div className="pdp-refine-plan grid">
      <div className="heading">
        <div className="heading-container">
          <Heading {...heading} typographyClass={"type-h3"} />
          {info && (
            <span className={"info-button"} onClick={openInfoModal}>
              <InfoIcon />
            </span>
          )}
        </div>
        {tabs && (
          <RangeOptionSelect
            {...tabs}
            onClick={option => {
              onTabSelected && onTabSelected(option);
              setCurrentTab(option);
            }}
          />
        )}
      </div>
      {!tabs || (currentTab && currentTab.value === tabs.defaultOption.value) ? (
        <div className="loan">
          <div className="option-grid">
            {plan &&
              plan.length > 0 &&
              sliders &&
              sliders.map((slider, index) => {
                return (
                  <Slider
                    key={index}
                    {...{
                      ...slider,
                      ...{
                        selected: plan[0][index],
                        value: plan[0][index]
                      }
                    }}
                    onChange={(value, val) => updatePlan(0, index, value, val)}
                  />
                );
              })}
          </div>
        </div>
      ) : (
        <CashOptions {...cashOptions} onChange={(index, value, val) => updatePlan(1, index, value, val)} />
      )}
      <div className="button-container">
        <BodyText html={disclaimerText} className="disclaimer" />
        <PrimaryButton
          {...{
            ...checkoutButton,
            link: { value: { ...checkoutButton?.link?.value, href: null, linktype: null } }
          }}
          callback={() => onCheckout(plan, null, "submit", checkoutButton?.link?.value)}
        />
      </div>
      <InfoModal {...info} showModal={showInfoModal} setShowModal={setShowInfoModal} />
    </div>
  );
};

PdpRefinePlan.propTypes = {
  heading: PropTypes.object,
  tabs: PropTypes.object,
  sliders: PropTypes.array,
  onOptionSelected: PropTypes.func,
  loanDisclaimer: PropTypes.object,
  cashOptions: PropTypes.shape({
    checkboxes: PropTypes.array,
    description: PropTypes.object,
    disclaimer: PropTypes.object,
    onChange: PropTypes.func
  }),
  checkoutButton: PropTypes.object,
  onCheckout: PropTypes.func
};

export default PdpRefinePlan;
